import { customElement } from "lit/decorators.js";
import { SugarElement } from "../configurator/SugarCanvas";
import { Engine, Entity } from "../engine/Engine";
import { GTAOPass } from "../engine/postprocesses/GTAOPass";

class GTAOPostProcessEntity extends Entity {
  private _gtaoPass?: GTAOPass;
  private _updateCameraInstace: any;
  private _interactionStartHandler = () => {
    if (this._gtaoPass) {
      this._gtaoPass.enabled = false;
      this.engine?.dispatchCustomEvent("request-update");
    }
  };
  private _interactionEndHandler = () => {
    if (this._gtaoPass) {
      this._gtaoPass.enabled = true;
      this.engine?.dispatchCustomEvent("request-update");
    }
  };

  private _syncGtaoSceneAndCamera(): void {
    const eng = this.engine;
    if (!this._gtaoPass || !eng?.activeCamera) return;
    this._gtaoPass.scene = eng.getSceneForWebGLRender();
    this._gtaoPass.camera = eng.activeCamera.instance;
  }

  private _onWebglRenderSceneChanged = () => {
    this._syncGtaoSceneAndCamera();
  };

  private updateCamera(_e?: unknown) {
    this._syncGtaoSceneAndCamera();
    this.engine?.removePass(this._gtaoPass);
    this.engine?.addPass(this._gtaoPass);
  }

  private addGTAOPass() {
    if (!this._gtaoPass) {
      const aoParameters = {
        radius: 0.25,
        distanceExponent: 2,
        thickness: 0.5,
        scale: 0.75,
        samples: 32,
        distanceFallOff: 1,
        screenSpaceRadius: false,
      };
      const pdParameters = {
        lumaPhi: 10,
        depthPhi: 2,
        normalPhi: 3,
        radius: 2,
        radiusExponent: 1,
        rings: 2,
        samples: 2,
      };
      this._gtaoPass = new GTAOPass(
        this.engine!.getSceneForWebGLRender(),
        this.engine!.activeCamera!.instance,
        1024,
        1024,
      );
      this._gtaoPass.updateGtaoMaterial(aoParameters);
      this._gtaoPass.updatePdMaterial(pdParameters);
      //this._gtaoPass.output = 4;

      this.engine?.removePass(this._gtaoPass);
      this.engine?.addPass(this._gtaoPass);
      this._updateCameraInstace = this.updateCamera.bind(this);
      this.engine?.addEventListener("update-camera", this._updateCameraInstace);
      this.engine?.addEventListener(
        "webgl-render-scene-changed",
        this._onWebglRenderSceneChanged,
      );
      this.engine?.addEventListener("interaction-start", this._interactionStartHandler);
      this.engine?.addEventListener("interaction-end", this._interactionEndHandler);
    }
  }

  onAdd(engine: Engine): void {
    this.addGTAOPass();
  }

  onRemove(engine: Engine): void {
    this.engine?.removePass(this._gtaoPass);
    this.engine?.removeEventListener("update-camera", this._updateCameraInstace);
    this.engine?.removeEventListener(
      "webgl-render-scene-changed",
      this._onWebglRenderSceneChanged,
    );
    this.engine?.removeEventListener("interaction-start", this._interactionStartHandler);
    this.engine?.removeEventListener("interaction-end", this._interactionEndHandler);
  }
}

@customElement("gtao-postprocess")
export class GTAOPostProcessElement extends SugarElement {
  createEntity(): Entity | undefined {
    return new GTAOPostProcessEntity();
  }
}
